import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { requestDestination } from '../actions/destination';
import { enableSubNavbar, setSubNavbar } from '../actions/navbar';

import ServiceSiteList from '../components/servicesite/ServiceSiteList';
import Instructions from '../components/instructions/Instructions';

class Destination extends React.Component {
  componentDidMount() {
    const { requestDestination, destinationId, destination } = this.props;

    if (this.updateNavbar(destination)) {
      requestDestination(destinationId);
    }
  }

  componentDidUpdate(prevProps) {
    const { destination: currentDestination } = prevProps;
    const { destination } = this.props;

    this.updateNavbar(destination, currentDestination);
  }

  updateNavbar(destination, currentDestination) {
    const { enableSubNavbar, setSubNavbar } = this.props;

    const {
      id, companyName, streetAddress, city, isPartial,
    } = destination;

    if (currentDestination !== undefined && id === currentDestination.id) {
      return false;
    }

    if (!id) {
      enableSubNavbar();
      return true;
    }

    const urlPathParts = window.location.href.split('/');
    const sourcePath = urlPathParts[urlPathParts.length - 1];
    setSubNavbar({
      title: [
        companyName,
        `${streetAddress}, ${city}`,
      ],
      backLink: (sourcePath === 'frontpage' ? '/' : '/deviations'),
    });

    return isPartial;
  }

  render() {
    const { destination = {}, translate } = this.props;
    const { id, serviceSites, instructions } = destination;

    let serviceSitesComponent;

    if (serviceSites && serviceSites.length === 0) {
      serviceSitesComponent = (
        <h4>{translate('destination_no_service_sites')}</h4>
      );
    } else {
      serviceSitesComponent = (
        <ServiceSiteList additionalInfo
                         serviceSites={(serviceSites || []).map((serviceSite) => ({
                           ...serviceSite,
                           link: `/servicesite/${id}/${serviceSite.id}`,
                         }))} />
      );
    }

    return (
      <div>
        <div className="container">
          <div className="row">
            <div className="visible-xs-block">
              <Instructions destination={destination} />
            </div>
            <div className="col-sm-6">
              <h1>{translate('service_site.plural')}</h1>
              {serviceSitesComponent}
            </div>
            {!!instructions
              && (
              <div className="col-sm-6">
                <Instructions className="hidden-xs" destination={destination} instructions={instructions} />
                <Instructions className="visible-xs-block" instructions={instructions} />
              </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state = {}, ownProps) => {
  const locale = state.locale || {};
  const destinationId = ownProps.params?.destinationId;
  const destinationMap = state.destination?.destinationMap || {};

  return {
    destinationId,
    destination: destinationMap[destinationId] || {},
    translate: getTranslate(locale),
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  enableSubNavbar,
  setSubNavbar,
  requestDestination,
}, dispatch);

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
                {...props}
                location={location}
                navigate={navigate}
                params={params} />
    );
  }
  return ComponentWithRouterProp;
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Destination));
